const c = {
  name: "FormulaGoodChoices",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.9 38.2" style="enable-background:new 0 0 39.9 38.2;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M37.1,3.7c-2-2.2-4.6-3.5-7.6-3.7c-3.8-0.2-7.4,1.6-9.5,4.7c-2.1-3-5.7-4.9-9.5-4.7C7.6,0.1,4.9,1.5,2.9,3.7
			C0.8,6.1-0.2,9.3,0,12.5c1.2,14,18.7,24.9,19.4,25.4l0.5,0.3l0.5-0.3c0.7-0.5,18.2-11.3,19.4-25.4C40.2,9.3,39.1,6.1,37.1,3.7
			L37.1,3.7z M37.9,12.3C37,23.1,25.2,32.2,21,35.1V24.1c5.3-0.3,8-3.3,8-9v-1h-1c-3.8,0-6.4,1.2-7.8,3.6C18.7,13.3,15,11.1,9,11.1
			H8v1c0,7.7,3.6,11.6,11,12v11.1C14.7,32.2,3,23.1,2,12.3C1.8,9.7,2.7,7,4.4,5C6,3.2,8.2,2.1,10.6,2c0.1,0,0.3,0,0.4,0
			c3.4,0,6.6,2,8.1,5.1L20,9l0.9-1.9c1.6-3.3,4.9-5.2,8.5-5.1c2.4,0.1,4.6,1.2,6.1,3C37.3,7,38.2,9.7,37.9,12.3L37.9,12.3z M21,22.1
			c0.3-3.8,2.1-5.7,5.9-5.9C26.7,20,24.9,21.8,21,22.1z M19,22.1c-5.9-0.3-8.7-3.1-8.9-9C15.9,13.4,18.7,16.2,19,22.1z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as FormulaGoodChoices
};
